export default {"src":"/_next/static/media/switch-token.1a2160a0.svg","height":28,"width":28};